module.exports = __webpack_public_path__ + "img/logo_u1992-24.61ef5997.svg";